export const PIE_COLOR_STOPS = [
  ["#C4B5FD", "#8B5CF6"],
  ["#67E8F9", "#06B6D4"],
  ["#FCD34D", "#F59E0B"],
  ["#F9A8D4", "#EC4899"],
  ["#6EE7B7", "#10B981"],
  ["#FCA5A5", "#EF4444"],
  ["#A5B4FC", "#6366F1"],
  ["#5EEAD4", "#14B8A6"],
];

export function pieFill(i) {
  return `url(#pie-color-${i % PIE_COLOR_STOPS.length})`;
}

export function PieGradientDefs() {
  return (
    <defs>
      {PIE_COLOR_STOPS.map(([light, base], i) => (
        <radialGradient key={i} id={`pie-color-${i}`} cx="35%" cy="30%" r="75%">
          <stop offset="0%" stopColor={light} />
          <stop offset="100%" stopColor={base} />
        </radialGradient>
      ))}
    </defs>
  );
}

export function PieLegend({ data, className = "" }) {
  return (
    <div className={`flex flex-wrap justify-center gap-x-4 gap-y-1.5 ${className}`} data-testid="pie-legend" style={{ fontFamily: "Arial, sans-serif" }}>
      {data.map((d, i) => (
        <span key={d.id || d.name} className="inline-flex items-center gap-1.5 text-xs" data-testid={`pie-legend-item-${i}`}>
          <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ background: `linear-gradient(135deg, ${PIE_COLOR_STOPS[i % PIE_COLOR_STOPS.length][0]}, ${PIE_COLOR_STOPS[i % PIE_COLOR_STOPS.length][1]})` }} />
          <span className="truncate max-w-[110px]">{d.name}</span>
        </span>
      ))}
    </div>
  );
}
